import React, { useRef } from 'react'
import Slider from 'react-slick'

const partners = [
  {
    name: 'Ministry of Roads',
    image: '/assets/images/partners/MinistryofRoads&Highways.png'
  },
  {
    name: 'Ghana Police MTTD',
    image: '/assets/images/partners/Ghana Police MTTD.png'
  },
  {
    name: 'Ghana Fire Service',
    image: '/assets/images/partners/Ghana Fire Service.png'
  },
  {
    name: 'GPRTU',
    image: '/assets/images/partners/GPRTU.png'
  },
  {
    name: 'Ghana Redcross',
    image: '/assets/images/partners/Ghana Redcross.png'
  },
  {
    name: 'Ghana Ambulance Service',
    image: '/assets/images/partners/Ghana Ambulance Service.png'
  },
  {
    name: 'NRSA',
    image: '/assets/images/partners/NRSA.png'
  }
]

const Partners = () => {
  const sliderRef = useRef(null)
  return (
    <div className='py-8 sm:py-12 md:py-16 bg-white'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='lg:text-center'>
          <h2 className='text-center text-3xl md:text-5xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl'>
            In Partners with
          </h2>
          <p className='mt-4 max-w-3xl text-xl text-gray-500 lg:mx-auto'>
            We team up with several multinational companies and corporations
            that are convinced by the solutions we offer in the transport
            industry
          </p>
        </div>

        <div className='mt-10 flex-1'>
          <Slider
            dots={false}
            ref={sliderRef}
            slidesToShow={6}
            slidesToScroll={1}
            infinite={true}
            autoplay={true}
            autoplaySpeed={5000}
            className='h-full'
            responsive={[
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 5
                }
              },
              {
                breakpoint: 425,
                settings: {
                  slidesToShow: 4
                }
              },
              {
                breakpoint: 375,
                settings: {
                  slidesToShow: 3
                }
              }
            ]}
          >
            {partners.map((partner, index) => (
              <div className='flex flex-col items-stretch h-full' key={index}>
                <img
                  src={partner.image}
                  className='mx-auto md:h-20 lg:h-24'
                  alt={partner.name}
                  data-aos='zoom-in'
                  data-aos-delay={`${index > 0 ? 300 * index : 0}`}
                  data-aos-duration='1000'
                />
                {/* <div className="pt-2 text-center">{partner.name}</div> */}
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  )
}
export default Partners
